import { render, staticRenderFns } from "./ikidsdetail.vue?vue&type=template&id=3e31e0bc&"
import script from "./ikidsdetail.vue?vue&type=script&lang=js&"
export * from "./ikidsdetail.vue?vue&type=script&lang=js&"
import style0 from "./ikidsdetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports